import useSWRImmutable from "swr/immutable";

import { useNetworkConfig } from "../../contexts/app/config";
import { STEP_API_ENDPOINT, swrFetcher } from "../../utils/swr";

// This represents the date which the xStep vault is first funded
const FUNDING_START = "2021-10-14";
const defaultXStepData = {
  apr: 0,
  stepPerXStep: 0,
  tvl: 0,
  price: 0,
};

export type XStepData = {
  apr: number;
  stepPerXStep: number;
  tvl: number;
  price: number;
};

export const useXStep = () => {
  const { network } = useNetworkConfig();
  const { data, mutate: refresh } = useSWRImmutable<XStepData>(
    // TODO: Use formatNetwork helper in solana-contrib (needs to be updated first)
    `${STEP_API_ENDPOINT}/v1/markets/xstep?cluster=${network}&funding_start=${FUNDING_START}`,
    swrFetcher,
  );

  const xStepData = data ?? defaultXStepData;

  return {
    xStepData,
    refresh,
  };
};
